<div class="news-detail-modal modal-bg" id="dark" [ngStyle]="(translate.currentLang=='ar') && {'direction': 'rtl', 'text-align': 'start'}">
  <div class="row">
    <div class="col-12">
      <h6 class="text-muted mb-3">{{"select-company-hintt" |translate}}</h6>

      <ng-select class="custom" [searchFn]="customSearchFn" #selectBuy [items]="companies" [clearable]="false" [searchable]="false" [(ngModel)]="company" [bindLabel]="(translate.currentLang == 'en')?'ENG_NAME':'ARB_NAME'">
        <ng-template ng-header-tmp>
          <div class="row">
            <div class="col-12">
              <input class="dropdown-input-style" style="width: 100%; line-height: 24px;" placeholder="{{translate.currentLang=='en'?'Search Here':'ابحث هنا'}}" type="text" (input)="selectBuy.filter($event.target.value)" />
            </div>
          </div>
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          {{company.Reuters}}
          <span> - </span>
          {{(translate.currentLang=='en')?company.ENG_NAME:company.ARB_NAME}}
        </ng-template>
      </ng-select>
      <br>
      <div style="text-align:end">
        <button (click)="navigateDetails()" [disabled]="!company" type="button" class="btn btn-primary text-center align-self-end">
          {{'preview'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
